import { render } from "./MinusIcon.vue?vue&type=template&id=35227c12&scoped=true"
import script from "./MinusIcon.vue?vue&type=script&lang=js"
export * from "./MinusIcon.vue?vue&type=script&lang=js"

import "./MinusIcon.vue?vue&type=style&index=0&id=35227c12&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35227c12"]])

export default __exports__